import { TMessageSchema } from '../../types/messages';
import { TOpenedChat } from '../../types/openedChats';
import { TChatImages } from '../../types/chatFiles';

interface IRemoveDeletedMessageImagesParams {
  openedChat: TOpenedChat;
  message: TMessageSchema;
}

/** Удаляет изображения удалённого сообщения из галереи чата. */
export function removeDeletedMessageImagesFromChat({
  openedChat,
  message,
}: IRemoveDeletedMessageImagesParams): TChatImages | null {
  const messageImages = message.files?.images;
  const chatImages = openedChat.images;

  if (!messageImages?.length || !chatImages?.files?.length) {
    return chatImages;
  }

  const deletedImageUids = new Set(messageImages.map(image => image.uid));

  return {
    ...chatImages,
    files: chatImages.files.filter(file => !deletedImageUids.has(file.uid)),
  };
}
